(() => {
  const cfg = window.SITE_CONFIG || {};

  // Skool CTAs: point at checkout when configured, otherwise the membership section
  document.querySelectorAll('[data-skool]').forEach(a => {
    if (cfg.skoolCheckoutUrl) {
      a.href = cfg.skoolCheckoutUrl;
      a.target = '_blank';
      a.rel = 'noopener';
    }
  });

  // Footer links
  const map = {
    instagram: cfg.instagramUrl,
    tiktok: cfg.tiktokUrl,
    email: cfg.contactEmail ? 'mailto:' + cfg.contactEmail : '',
    privacy: cfg.privacyUrl,
    terms: cfg.termsUrl
  };
  document.querySelectorAll('[data-link]').forEach(a => {
    const v = map[a.dataset.link];
    if (v) { a.href = v; if (!v.startsWith('mailto:')) { a.target = '_blank'; a.rel = 'noopener'; } } else { a.hidden = true; }
  });
  document.querySelectorAll('.foot nav').forEach(n => { if (!n.querySelector('a:not([hidden])')) n.hidden = true; });

  // Intro video
  const vid = document.getElementById('intro-video');
  const v = vid && vid.querySelector('video');
  const ov = vid && vid.querySelector('.video__ph--overlay');
  if (v && ov) {
    ov.addEventListener('click', () => { v.controls = true; vid.classList.add('is-playing'); v.play(); v.focus(); });
    v.addEventListener('play', () => { v.controls = true; vid.classList.add('is-playing'); });
  }
  if (vid && cfg.introVideoEmbedUrl) {
    vid.innerHTML = '<iframe src="' + cfg.introVideoEmbedUrl + '" title="Christian Strandberg introduction" allow="accelerometer; autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
  }

  // Nav state
  const nav = document.getElementById('nav');
  const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 24);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // Mobile menu
  const tog = document.querySelector('.nav__toggle');
  const mnav = document.getElementById('mnav');
  tog.addEventListener('click', () => {
    const open = tog.getAttribute('aria-expanded') === 'true';
    tog.setAttribute('aria-expanded', String(!open));
    tog.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    nav.classList.toggle('is-open', !open);
  });
  mnav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    tog.setAttribute('aria-expanded', 'false');
    nav.classList.remove('is-open');
  }));

  // FAQ accordion
  document.querySelectorAll('.acc__item button').forEach(btn => {
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      btn.closest('.acc__item').classList.toggle('is-open', !open);
    });
  });

  // Entrance animations
  const els = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(el => io.observe(el));
  } else {
    els.forEach(el => el.classList.add('in'));
  }
  requestAnimationFrame(() => document.body.classList.add('ready'));
})();

// Open external story links in a new tab
document.querySelectorAll('.story a[href^="http"]').forEach(a => { a.target = '_blank'; a.rel = 'noopener'; });
